import { render, staticRenderFns } from "./AddPurchasesOrderPage.vue?vue&type=template&id=09cb18e7"
import script from "./AddPurchasesOrderPage.vue?vue&type=script&lang=js"
export * from "./AddPurchasesOrderPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports